var menu_1 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_1').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_1', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_1').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_1', {duration:0, fps:40})},0);
  }
 }
}
var menu_2 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_2').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_2', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_2').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_2', {duration:0, fps:40})},0);
  }
 }
}
var menu_3 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_3').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_3', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_3').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_3', {duration:0, fps:40})},0);
  }
 }
}

var menu_4 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_4').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_4', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_4').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_4', {duration:0, fps:40})},0);
  }
 }
}

var menu_5 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_5').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_5', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_5').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_5', {duration:0, fps:40})},0);
  }
 }
}

var menu_6 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_6').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_6', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_6').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_6', {duration:0, fps:40})},0);
  }
 }
}

var menu_7 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_7').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_7', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_7').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_7', {duration:0, fps:40})},0);
  }
 }
}


var menu_8 = {
 timeout : null,
 showPopup : function(){
  clearTimeout(this.timeout);
  if($('menu_8').style.display == 'none'){
   this.timeout = setTimeout(function(){new Effect.BlindDown('menu_8', {duration:0, fps:40})},0);
  }
 },
 hidePopup : function(){
  if($('menu_8').style.display == 'none'){
   clearTimeout(this.timeout);
  }else{
   this.timeout = setTimeout(function(){new Effect.BlindUp('menu_8', {duration:0, fps:40})},0);
  }
 }
}